// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-manager-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
}

.card-manager-modal {
    background: white;
    padding: 24px;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    max-height: 85vh;
}

.card-manager-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 10px;
}

.card-manager-header h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a202c;
    margin: 0;
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #718096;
    padding: 0;
    line-height: 1;
}

.close-btn:hover {
    color: #4a5568;
}

.card-form {
    background-color: #f7fafc;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.card-form h4 {
    margin-top: 0;
    margin-bottom: 12px;
    font-size: 1rem;
    color: #2d3748;
}

.form-row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}

.form-group {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.form-group label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #4a5568;
}

.form-group input {
    padding: 8px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.95rem;
}

.form-group input:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
}

.btn-add,
.btn-save {
    background-color: #48bb78;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.2s;
    width: 100%;
}

.btn-add:hover,
.btn-save:hover {
    background-color: #38a169;
}

.btn-cancel {
    background-color: #edf2f7;
    color: #4a5568;
    border: 1px solid #cbd5e0;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    width: 100%;
}

.cards-list {
    flex: 1 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.card-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    transition: all 0.2s;
}

.card-item:hover {
    border-color: #cbd5e0;
}

.card-info h5 {
    margin: 0;
    font-size: 1rem;
    color: #2d3748;
}

.card-info p {
    margin: 2px 0 0;
    font-size: 0.85rem;
    color: #718096;
}

.card-actions {
    display: flex;
    gap: 8px;
}

.icon-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    padding: 4px;
    border-radius: 4px;
    transition: background 0.2s;
}

.icon-btn:hover {
    background-color: #edf2f7;
}

.icon-btn.delete {
    color: #e53e3e;
}

.icon-btn.delete:hover {
    background-color: #fff5f5;
}`, "",{"version":3,"sources":["webpack://./src/components/CardManagerModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iFAAiF;IACjF,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".card-manager-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1100;\r\n}\r\n\r\n.card-manager-modal {\r\n    background: white;\r\n    padding: 24px;\r\n    border-radius: 12px;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: 85vh;\r\n}\r\n\r\n.card-manager-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.card-manager-header h2 {\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n    color: #1a202c;\r\n    margin: 0;\r\n}\r\n\r\n.close-btn {\r\n    background: none;\r\n    border: none;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    color: #718096;\r\n    padding: 0;\r\n    line-height: 1;\r\n}\r\n\r\n.close-btn:hover {\r\n    color: #4a5568;\r\n}\r\n\r\n.card-form {\r\n    background-color: #f7fafc;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.card-form h4 {\r\n    margin-top: 0;\r\n    margin-bottom: 12px;\r\n    font-size: 1rem;\r\n    color: #2d3748;\r\n}\r\n\r\n.form-row {\r\n    display: flex;\r\n    gap: 12px;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.form-group {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n}\r\n\r\n.form-group label {\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    color: #4a5568;\r\n}\r\n\r\n.form-group input {\r\n    padding: 8px 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.form-group input:focus {\r\n    outline: none;\r\n    border-color: #3182ce;\r\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);\r\n}\r\n\r\n.btn-add,\r\n.btn-save {\r\n    background-color: #48bb78;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    transition: background 0.2s;\r\n    width: 100%;\r\n}\r\n\r\n.btn-add:hover,\r\n.btn-save:hover {\r\n    background-color: #38a169;\r\n}\r\n\r\n.btn-cancel {\r\n    background-color: #edf2f7;\r\n    color: #4a5568;\r\n    border: 1px solid #cbd5e0;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    width: 100%;\r\n}\r\n\r\n.cards-list {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.card-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 12px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    background: white;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.card-item:hover {\r\n    border-color: #cbd5e0;\r\n}\r\n\r\n.card-info h5 {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n    color: #2d3748;\r\n}\r\n\r\n.card-info p {\r\n    margin: 2px 0 0;\r\n    font-size: 0.85rem;\r\n    color: #718096;\r\n}\r\n\r\n.card-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.icon-btn {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 1.1rem;\r\n    padding: 4px;\r\n    border-radius: 4px;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.icon-btn:hover {\r\n    background-color: #edf2f7;\r\n}\r\n\r\n.icon-btn.delete {\r\n    color: #e53e3e;\r\n}\r\n\r\n.icon-btn.delete:hover {\r\n    background-color: #fff5f5;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
